import { baseUrl } from '../shared/constant/Key';
import axios from 'axios';

export default class HttpCall {

    static getInstance() {
        if (HttpCall.myInstance == null) {
            HttpCall.myInstance = new HttpCall();

        }
        return this.myInstance;
    }

    static getRequest = (url) => {
        let headers = { "Content-Type": "application/json" };
        // let token = this.helper.getAuthToken();
        // if (token) {
        //     headers["Authorization"] = `Token ${token}`;
        // }
        return fetch(url, { headers, })
            .then(response => response.json())
            .then((data) => {
                return data;
            }).catch(error => { return error })
    }

    static getRequest2 = (url) => {
        let user = JSON.parse(localStorage.getItem('user'));
        let headers = { "Content-Type": "multipart/form-data" };
        headers["Authorization"] = `Token ${user[0].token}`;

        return fetch(url)
            .then(response => response.json())
            .then((data) => {
                return data;
            }).catch(error => { return error })
    }

    static postRequest = (url, params) => {
        return axios({
            method: "post",
            url: baseUrl + url,
            data: params,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error;
        });
    }

    static postRequest2 = (url, params) => {
        let user = JSON.parse(localStorage.getItem('user'));
        let headers = { "Content-Type": "multipart/form-data" };
        headers["Authorization"] = `Token ${user[0].token}`;
        return axios({
            method: "post",
            url: baseUrl + url,
            data: params,
            headers: headers,
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error;
        });
    }

    // static postRequest = (url, params) => {
    //     // let token = this.helper.getAuthToken();
    //     let header = {
    //         //'Accept': 'application/json',
    //         'Content-Type': 'multipart/form-data',
    //     }
    //     // if (token) {
    //     //     header["Authorization"] = `Token ${token}`;
    //     // }
    //     return fetch(baseUrl+url, {
    //         method: 'POST',
    //         headers: header,
    //         body: params
    //     })
    //     .then(response => {
    //         if(!response.ok)  return response.json(); 
    //         else return response.json();
    //     })
    //     .then((data)=> {
    //         return data;
    //     }).catch( (error) => { return false })
    // }
}